<template>
<div v-if="readyInterval==-1" class="row input" :class="{'value-127':this.value==-127,'value-9':this.value==-9,'value-ok':this.value!=-9 && this.value!=-127,'nc-false':item.nr!=-127}">
   <div v-if="item.nr==-127" class="col yo-align-left"  :class="{s4: this.nc==1,s12: this.nc<1}">
      <el-select v-model="nc" placeholder="Selezionare" v-on:change="ncChange" v-on:input="ncChange" style="width:100%" clearable>
         <!-- <el-option label="Selezionare" :value="0" ></el-option> -->
         <el-option label="Conosciuto" :value="1" ></el-option>
         <el-option v-if="item.nc!=0" label="Non Conosciuto" :value="-1" ></el-option>
      </el-select>
   </div>
   <div class="col yo-align-right" :class="{s8: item.nr!=0,s12: item.nr==0}">
      <el-input v-if="(nc == 1)" v-bind:value.sync="value" v-on:change="updateValue" v-on:input="updateValue"  ></el-input>
   </div>
     <!-- {{value}} :: {{nc}} ::  -->
   </div>
</template>

<script>
export default {
      name: 'FormRange',
      model: {
      // By default, `v-model` reacts to the `input`
      // event for updating the value, we change this
      // to `change` for similar behavior as the
      // native `<select>` element.
      event: 'change',
   },
   data() {
      return {
         readyInterval:0
         ,nc: ''
      }
   },
   watch: {
      value: function(val){
         console.log("THIS.VALUE is now "+val)
         this.action4value(val)
         
       
      }
   },
   props: ['value','variabile'],
   mounted () {
      console.log("Created form for variable "+this.variabile)

      this.readyInterval = setInterval(() => { 
         console.log("Before action4value form for "+this.variabile+" the values is "+this.value +' and nc '+this.nc)
         if(typeof this.value != 'undefined'){
            
            this.action4value(this.value)
            console.log("After action4value form for "+this.variabile+" the values is "+this.value +' and nc '+this.nc)

            clearInterval(this.readyInterval)
            this.readyInterval = -1
         }
      }, 1000)


      
   },
   destroyed(){
      //if( this.readyInterval != -1)
         clearInterval(this.readyInterval)
   },

   methods: {
      action4value(val){
         if(this.item.nc==val && this.item.nc!=0)
             this.nc=-1
         if(val!=-127 && this.item.nc!=val)
            this.nc=1
         if(val==-127 && this.nc==1){
            console.log("THIS.VALUE is need to be set to vuoto")
            this.$emit('change','')
         }         
      },
      ncChange(e){
         console.log("NC: "+e)

         switch(e){
            case -1:
            console.log("NON CONOSCIUTO itemNC is "+this.item.nc)
            this.$emit('change', this.item.nc)
            break;

            case 1:
            console.log("CONOSCIUTO")
            let value = (this.value==this.item.nc) ? -127 : this.value
            this.action4value(value)
            break;

            default:
            console.log("NON RISPOSTO")
            this.$emit('change', -127)
         }

      },
      checkValue (e) {
         console.log('checkValue: '+e)
         console.log(e)
      },
      updateValue (e) {
         console.log("updateValue con e = "+e) 
         this.$emit('change', e)
      }
   },
   computed:{
      item:function(){
         let item = this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)
         //if(item.nc==this.value)
           // this.nc=false
         return item
      }
  }
}
</script>